const metaData = {
  fields: [
    'id',
    'name',
    'count',
    'request_type',
    'grade_id',
    { grade: ['name'] },
    'topic_id',
    { topic: ['name'] },
    'subject_id',
    { subject: ['name'] },
    'theme_id',
    { theme: ['name'] },
    'sub_theme_id',
    { sub_theme: ['name'] },
    'report_theme_id',
    { report_theme: ['name'] },
    'question_type_id',
    { question_type: ['name'] },
    'teacher_level_id',
    { teacher_level: ['name'] },
    'bloom_level_id',
    { bloom_level: ['name'] },
    'difficulty_level_id',
    { difficulty_levels: ['name'] },
    'centa_standard_id',
    { centa_standard: ['name'] },
    'strand_id',
    { strands: ['name'] },
    'competency_id',
    { competencies: ['name'] },
    'request_id',
    'description',
    'variant_options',
    'status',
    'due_date',
    'created_at',
    'questions',
    'taxonomy_id',
    { taxonomy: ['id', 'name'] },
    { questions: ['title', 'status', 'active', 'id', 'reviewer_id', 'approver_id', 'creator_id'] },
    'creator_id',
    { userByCreatorId: ['displayName'] },
    'reviewer_ids',
    'approver_ids',
    'paper_id',
    'completion_status',
    'all_approver_ids',
    // {question_reviewer_approver:['id',
    //   'reviewer_id',
    //   'approver_id',
    //   'question_id',
    //   'work_request_id',{work_request:['id','name']},{questions:['id','title']},{reviewer:['displayName', 'id']},{approver:['displayName', 'id']}]},

    { workRequestReviewers: ['id', 'user_id', { userByReviewerId: ['displayName', 'id'] }] },
    {
      workRequestApprovers: [
        'id',
        'approver_id',
        { userByApprover: ['displayName', 'id'] },
        'reviewer_id',
        { userByReviewerId: ['displayName', 'id'] },
      ],
    },
    'created_by',
    'paper_id',
    'paper_setter_id',
    'paper_wr_type',
    'grade_ids',
    'subject_incharge_id',
    { workRequestGrades: ['id', 'grade_id', { grade: ['name'] }] },
    'sub_section_id',
    { sub_section: ['id', 'name', 'subject_id', 'report_theme_id', 'theme_id', 'sub_theme_id', 'topic_id'] },
  ],
}

export default metaData
